import { useEffect, useState, type DependencyList } from 'react';

export const useFirestoreSubscription = <T>(
  subscribe: (onData: (data: T[]) => void, onError: (error: Error) => void) => () => void,
  deps: DependencyList
) => {
  const [data, setData] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = subscribe(
      (nextData) => {
        setData(nextData);
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      }
    );

    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- caller owns the dependency list; subscribe is re-created on every render
  }, deps);

  return {
    data,
    isLoading: loading,
    error,
  };
};
